import { isRight } from "fp-ts/Either";
import { Json, JsonFromString } from "io-ts-types";

export const getJSONScriptData = (elemID: string): Json => {
    const contextElem = document.getElementById(elemID);
    const jsonStr = contextElem?.textContent || "{}";
    const maybeData = JsonFromString.decode(jsonStr);
    if (isRight(maybeData)) {
        return maybeData.right;
    }
    return null;
};
